const config = {
  BASE_URL: process.env.REACT_APP_DOMAIN || "",
  API_BASE_URL: `${process.env.REACT_APP_DOMAIN || ""}/api`,
  API_VERSION: "/v1",
  REQUEST_TIMER: 30000,
};

export default config;
